module.exports = __webpack_public_path__ + "media/images/amenities_icons/slack_channel-1bef7c68f1b922d96060f95c9e9cf43f.svg";